var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',[_vm._v("The Midnight Miracle is coming soon to vinyl. For updates on pre-order, share your email address in the form below.")])])}]

export { render, staticRenderFns }